var _path, _path2, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleGymnectBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 186,
    viewBox: "0 0 281 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.68 53.2967L193.517 96.0742C194.238 96.6171 194.75 97.4031 194.763 98.3058C194.772 98.948 194.723 99.7742 194.524 100.701C194.179 102.306 192.506 103.114 190.886 102.852L124.794 92.182L130.681 55.712C131.134 52.9057 134.409 51.5873 136.68 53.2967Z",
    fill: "#0060BF",
    stroke: "#0060BF",
    strokeWidth: 0.377619
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.695 131.391L91.8582 88.6132C91.137 88.0703 90.6247 87.2843 90.6121 86.3816C90.6032 85.7394 90.6524 84.9132 90.8515 83.9861C91.196 82.3815 92.8686 81.5738 94.4888 81.8354L160.582 92.5054L154.694 128.975C154.241 131.782 150.966 133.1 148.695 131.391Z",
    fill: "#0060BF",
    stroke: "#0060BF",
    strokeWidth: 0.377619
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.4688,
    y: 2.09766,
    width: 88.5838,
    height: 146.883,
    rx: 17.1987,
    transform: "rotate(8.40686 21.4688 2.09766)",
    fill: "#0060BF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 193.086,
    y: 25.3164,
    width: 88.5838,
    height: 146.883,
    rx: 17.1987,
    transform: "rotate(8.40686 193.086 25.3164)",
    fill: "#0060BF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleGymnectBackground);
export default __webpack_public_path__ + "static/media/title-gymnect-background.5dd8c242b01b733457928e1f77af0eef.svg";
export { ForwardRef as ReactComponent };